function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M576 64c35.346 0 64 28.654 64 64v384c0 35.346-28.654 64-64 64H64c-35.346 0-64-28.654-64-64V128c0-35.2 28.8-64 64-64h512zM436.16 355.2L640 512v-64L476.16 323.2 640 192v-64L320 384 0 128v64l163.84 131.2L0 448v64l203.84-156.8L320 448l116.16-92.8z"
});

var SvgEnvelope = function SvgEnvelope(props) {
  return React.createElement("svg", _extends({
    width: 640,
    height: 640,
    viewBox: "0 0 640 640"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PCEtLSBHZW5lcmF0ZWQgYnkgSWNvTW9vbi5pbyAtLT4KPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjY0MCIgaGVpZ2h0PSI2NDAiIHZpZXdCb3g9IjAgMCA2NDAgNjQwIj4KPHRpdGxlPjwvdGl0bGU+CjxnIGlkPSJpY29tb29uLWlnbm9yZSI+CjwvZz4KPHBhdGggZD0iTTU3NiA2NGMzNS4zNDYgMCA2NCAyOC42NTQgNjQgNjR2MCAzODRjMCAzNS4zNDYtMjguNjU0IDY0LTY0IDY0djBoLTUxMmMtMzUuMzQ2IDAtNjQtMjguNjU0LTY0LTY0djAtMzg0YzAtMzUuMiAyOC44LTY0IDY0LTY0aDUxMnpNNDM2LjE2IDM1NS4ybDIwMy44NCAxNTYuOHYtNjRsLTE2My44NC0xMjQuOCAxNjMuODQtMTMxLjJ2LTY0bC0zMjAgMjU2LTMyMC0yNTZ2NjRsMTYzLjg0IDEzMS4yLTE2My44NCAxMjQuOHY2NGwyMDMuODQtMTU2LjggMTE2LjE2IDkyLjggMTE2LjE2LTkyLjh6Ij48L3BhdGg+Cjwvc3ZnPgo=";
export { SvgEnvelope as ReactComponent };